export default "__VITE_ASSET__34597a4f__"